import React, { useEffect, useState } from 'react'
import inspectionQueries from '../../../queries/inspectionQueries'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../components/Loader'
import { Badge, Button, Radio, RadioGroup } from '@nextui-org/react'
import { useApi } from '../../../utils/ApiProvider'
import { useNavigate } from 'react-router-dom'
import { setQuestionId } from '../../../redux/reducers/inspectionReducers'
import { RouteConstant } from '../../../routes/RouteConstant'
import BreadCrumbs from '../../../components/BreadCrumbs'

const breadCrumbsData = [
    {
        url: RouteConstant.ROOT,
        name: 'Inspections'
    },
    {
        url: RouteConstant.SECTIONPROGRESS,
        name: 'Sections'
    },
    {
        url: RouteConstant.QUESTIONPROGRESS,
        name: 'Questions'
    }
]

const QuestionProgress = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const section_id = useSelector((state) => state.inspection.section_id)
    const inspection_id = useSelector((state) => state.inspection.inspection_id)

    const [result, setResult] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const { apiData, setApiDataAndNotify } = useApi()

    const getData = inspectionQueries.useQuestionProgress(
        (res)=>{
            if(res?.success){
                setResult(res?.data)
            }
            setIsLoading(false)
        }
    )

    useEffect(() => {
        getData.mutateAsync({section_id, inspection_id})
    }, [apiData]);

    const RadioData = [
        { name: 'Good', value: 'DONE', color: 'success', colorCode: '#17C964' },
        { name: 'Unsatisfactory', value: 'NOT_DONE', color: 'danger', colorCode: '#F31260' },
        { name: 'Not Applicable', value: 'NOT_APPLICABLE', color: 'primary', colorCode: '#246AFD' },
        { name: 'Not Seen', value: "PENDING", color: 'warning', colorCode: '#F5A524' },
    ]

    const insertAction = inspectionQueries.useInsertQuestionActionData(
        async(res) => {
            if(res?.success){
                setApiDataAndNotify(new Date())
            }
        }
    )

    const handleAction = (item, value) => {
        const data = {
            question_id: item?.id,
            inspection_id,
            action: value
        };
        insertAction.mutateAsync([data])
    }

    const handleNavigate = (data) => {
        dispatch(setQuestionId(data?.id))
        navigate(RouteConstant.REMARKSCREEN)
    }
    
  return (
    <div className='gap-4'>

        <BreadCrumbs  data={breadCrumbsData} />

        {
            isLoading ?
            <div className="w-full flex items-center justify-center py-40">
                <Loader />
            </div>:
            <div>
                {
                    result?.map((data, index) => {
                    const actionValue = data?.question_action?.action;
                    const selectedAction = actionValue
                        ? RadioData.find((radio) => radio.value === actionValue)
                        : RadioData.find((radio) => radio.value === 'PENDING');
                    return (
                        <div style={{borderColor: selectedAction ? selectedAction?.colorCode : "#F5A524" }} className='border-[2px] bg-slate-50 w-full p-5 mb-5 rounded-[20px] shadow-md flex justify-between items-center' key={index}>
                            <div className='w-full flex flex-col items-start gap-2'>
                                <span className='font-medium text-[14px]'>{data?.name}</span>
                                <div className='w-full flex justify-between items-center'>
                                    <RadioGroup
                                    onValueChange={(value) => handleAction(data, value)}
                                    orientation="horizontal"
                                    defaultValue={selectedAction?.value}
                                    >
                                        {RadioData.map((radio, index) => (
                                            <Radio
                                            className="!text-[12px]"
                                            key={index}
                                            value={radio.value}
                                            color={radio.color}
                                            >
                                                <span className="text-[13px] font-medium">{radio.name}</span>
                                            </Radio>
                                        ))}
                                    </RadioGroup>
                                    <Badge color='danger' shape='circle' classNames={{badge:'text-[12px]'}} content={data?.remarkCount}>
                                        <Button
                                        size='sm'
                                        onClick={()=> {handleNavigate(data)}}
                                        className='font-medium text-[14px] bg-primary text-white px-3 w-fit rounded-[10px]'>
                                            Remark
                                        </Button>
                                    </Badge>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        }
    </div>
  )
}

export default QuestionProgress
